import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {ControlContainer, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SlimLoadingBarModule} from 'ng2-slim-loading-bar';
import {
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    CheckboxModule,
    DataTableModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    GMapModule,
    LightboxModule,
    MessagesModule,
    MultiSelectModule,
    OverlayPanelModule,
    RadioButtonModule,
    SharedModule,
    TabViewModule,
    ToggleButtonModule,
    TooltipModule,
} from 'primeng/primeng';
import {CampaignRouting} from './campaign.routing';
import {ImageCropperModule} from 'ng2-img-cropper';
import {CampaignCreateComponent} from './campaign-create/campaign-create.component';
import {CampaignManageComponent} from './campaign-manage/campaign-manage.component';
import {CampaignCompleteComponent} from './campaign-complete/campaign-complete.component';
import {OrderFormComponent} from './order-form/order-form.component';
import {OrderSummaryComponent} from './order-summary/order-summary.component';
import {CampaignComponent} from './campaign.component';
import {FundraiserOrderMaterialsService} from '../orders/materials/fundraiser-order-materials.service';
import {SettingsService} from '../settings/settings.service';
import {AccountService} from '../account/account.service';
import {OrdersService} from '../shared/services/orders.service';
import {WeekBeginDeltaPipe} from './WeekBeginDeltaPipe';
import {WeekEndDeltaPipe} from './WeekEndDeltaPipe';
import {UserService} from '../users/user.service';
import {ScrollTopService} from '../shared/services/scroll-top.service';
import {CampaignFinalOrderComponent} from './campaign-final-order/campaign-final-order.component';

@NgModule({
    imports: [
        CommonModule,
        CampaignRouting,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        SharedModule,
        MultiSelectModule,
        ToggleButtonModule,
        ButtonModule,
        TabViewModule,
        RadioButtonModule,
        DropdownModule,
        FileUploadModule,
        GMapModule,
        CalendarModule,
        MessagesModule,
        LightboxModule,
        DialogModule,
        AutoCompleteModule,
        OverlayPanelModule,
        TooltipModule,
        ImageCropperModule,
        SlimLoadingBarModule.forRoot(),
        CheckboxModule,
    ],

    providers: [
        FundraiserOrderMaterialsService,
        SettingsService,
        AccountService,
        OrdersService,
        UserService,
        ScrollTopService,
        ControlContainer,
        DatePipe
    ],
    declarations: [
        CampaignComponent,
        CampaignCreateComponent,
        CampaignManageComponent,
        CampaignCompleteComponent,
        OrderFormComponent,
        OrderSummaryComponent,
        WeekBeginDeltaPipe,
        WeekEndDeltaPipe,
        CampaignFinalOrderComponent
    ]
})
export class CampaignModule {
}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign.module.ts